/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PermissionsConfigProviderEntryEntrypointProps } from './PermissionsConfigProviderEntry.entrypoint.types.tsx';

type PermissionsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	PermissionsConfigProviderEntryEntrypointProps,
	{} | null
>;

export const permissionsConfigProviderEntrypoint: EntryPoint<
	PermissionsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<PermissionsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-permissions-provider" */ './PermissionsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
